import React from 'react';
import { Box } from '../core';
import { ITxStatus } from '@sc1/common/utils';
import { StatusButton } from '../StatusButton';

export const UpdateButton = ({
  onClick,
  visible,
  disabled,
}: {
  onClick: any;
  visible: boolean;
  disabled: boolean;
}) => (
  <StatusButton
    variant="miniStatusButton"
    sx={{
      position: 'absolute',
      right: 7,
      top: 2,
      zIndex: 5,
      visibility: visible ? 'visible' : 'hidden',
    }}
    status={ITxStatus.SUCCESS}
    disabled={disabled}
    onClick={onClick}
  >
    Update Backtest
  </StatusButton>
);
